/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { group, row, stack } from '@wordpress/icons';
const variations = [{
  name: 'group',
  title: __('Group'),
  description: __('Gather blocks in a layout container.'),
  attributes: {
    layout: {
      type: 'default'
    }
  },
  scope: ['transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo, _blockAttributes$layo2;

    return !blockAttributes.layout || !((_blockAttributes$layo = blockAttributes.layout) !== null && _blockAttributes$layo !== void 0 && _blockAttributes$layo.type) || ((_blockAttributes$layo2 = blockAttributes.layout) === null || _blockAttributes$layo2 === void 0 ? void 0 : _blockAttributes$layo2.type) === 'default';
  },
  icon: group
}, {
  name: 'group-row',
  title: __('Row'),
  description: __('Arrange blocks horizontally.'),
  attributes: {
    layout: {
      type: 'flex',
      flexWrap: 'nowrap'
    }
  },
  scope: ['inserter', 'transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo3, _blockAttributes$layo4, _blockAttributes$layo5;

    return ((_blockAttributes$layo3 = blockAttributes.layout) === null || _blockAttributes$layo3 === void 0 ? void 0 : _blockAttributes$layo3.type) === 'flex' && (!((_blockAttributes$layo4 = blockAttributes.layout) !== null && _blockAttributes$layo4 !== void 0 && _blockAttributes$layo4.orientation) || ((_blockAttributes$layo5 = blockAttributes.layout) === null || _blockAttributes$layo5 === void 0 ? void 0 : _blockAttributes$layo5.orientation) === 'horizontal');
  },
  icon: row
}, {
  name: 'group-stack',
  title: __('Stack'),
  description: __('Arrange blocks vertically.'),
  attributes: {
    layout: {
      type: 'flex',
      orientation: 'vertical'
    }
  },
  scope: ['inserter', 'transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo6, _blockAttributes$layo7;

    return ((_blockAttributes$layo6 = blockAttributes.layout) === null || _blockAttributes$layo6 === void 0 ? void 0 : _blockAttributes$layo6.type) === 'flex' && ((_blockAttributes$layo7 = blockAttributes.layout) === null || _blockAttributes$layo7 === void 0 ? void 0 : _blockAttributes$layo7.orientation) === 'vertical';
  },
  icon: stack
}];
export default variations;
//# sourceMappingURL=variations.js.map